import { render, staticRenderFns } from "./SelectBoxTemplate.vue?vue&type=template&id=25147365&"
import script from "./SelectBoxTemplate.vue?vue&type=script&lang=js&"
export * from "./SelectBoxTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports